/**
 * Logout iframe target — used for cross-domain cookie wipe.
 *
 * When a user logs out on zibby.dev (or .app), AuthService.logout()
 * embeds a hidden iframe pointing at the OTHER domain's
 * /logout-iframe. This page runs clearAuthCookies() in THAT domain's
 * context so cookies on both .zibby.app AND .zibby.dev get wiped in
 * one logout action.
 *
 * Without this, a session lingering on the deprecated zibby.app
 * domain could shadow a fresh zibby.dev login if the user later
 * visited a .zibby.app subdomain (the historical CLI auth bug
 * 2026-05-09).
 *
 * No UI — runs once on mount, exits silently.
 */
import { useEffect } from 'react';
import { clearAuthCookies } from '../../utils/crossDomainAuth';

const LogoutIframePage = () => {
  useEffect(() => {
    try {
      clearAuthCookies();
      // Ping the parent if there is one (informational; parent doesn't
      // strictly wait for this — the AuthService.logout setTimeout is
      // the timing primitive that ensures we get a chance to run).
      if (window.parent && window.parent !== window) {
        try { window.parent.postMessage({ type: 'zibby-cross-domain-logout-done' }, '*'); } catch { /* noop */ }
      }
    } catch { /* always silent — never block parent's logout flow */ }
  }, []);

  return null;
};

export default LogoutIframePage;
